import { observer } from 'mobx-react';

import type { EntryData } from 'chaika-frontend-types/frontend-cms';

import { EditEntryDataTab } from './hooks/useSelectionButtons';

import { DateForm } from './forms/DateForm';
import { CoAuthorsForm } from './forms/CoAuthorsForm';
import { EntryDataForm } from './forms/EntryDataForm';

interface Props extends FormProps {
    tab: EditEntryDataTab;
}

export interface FormProps {
    entry: EntryData;
}

const formFor: Record<EditEntryDataTab, React.FC<FormProps>> = {
    [EditEntryDataTab.EntryData]: EntryDataForm,
    [EditEntryDataTab.Date]: DateForm,
    [EditEntryDataTab.CoAuthors]: CoAuthorsForm,
};

export const EditEntryDataForm = observer(({ tab, entry }: Props): React.ReactElement<any> => {
    const Form = formFor[tab];
    return <Form entry={entry} />;
});
